import script from "./ProductDetailProductFeatures.vue?vue&type=script&setup=true&lang=js"
export * from "./ProductDetailProductFeatures.vue?vue&type=script&setup=true&lang=js"

import "./ProductDetailProductFeatures.vue?vue&type=style&index=0&id=243247fc&lang=scss&scoped=true"

import exportComponent from "/app/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-243247fc"]])

export default __exports__